import {createSlice} from '@reduxjs/toolkit';
import {loadExtraServices, loadExtras} from './actions';
import {ExtrasState} from './types';
import {getEmptyServicesByCategoryAndBuildingId} from './utils';

const initialState: ExtrasState = {
  isLoading: false,
  extras: [],

  extraServicesLoadingStatus: 'NotLoaded',
  extraServicesByCategoryByBuilding: getEmptyServicesByCategoryAndBuildingId(),
};

const slice = createSlice({
  name: 'extras',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadExtras.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(loadExtras.fulfilled, (state, action) => {
        state.isLoading = false;
        state.extras = action.payload;
      })
      .addCase(loadExtras.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(loadExtraServices.pending, (state) => {
        state.extraServicesLoadingStatus = 'Loading';
      })
      .addCase(loadExtraServices.fulfilled, (state, action) => {
        state.extraServicesLoadingStatus = 'Loaded';
        state.extraServicesByCategoryByBuilding = action.payload;
      })
      .addCase(loadExtraServices.rejected, (state) => {
        state.extraServicesLoadingStatus = 'Failed';
      });
  },
});

export const {reducer: extrasReducer} = slice;
